import React from 'react';
import '../../assets/css/required-field-indicator.scss';

interface Props {
  message?: string;
}

const RequiredFieldMessage = (props: Props) => {
  return (
    <p data-testid="required-indicator-with-text" className="required-indicator-with-text">
      <span>*</span> {props.message ? props.message : 'mandatory fields'}
    </p>
  );
};

const RequiredFieldIndicator = () => {
  return (
    <span data-testid="required-indicator" className="required-indicator">
      *
    </span>
  );
};

export { RequiredFieldMessage, RequiredFieldIndicator };
